const toTop = document.getElementById("toTop");

// Function to check scroll position
const toggleVisible = () => {
  if (window.scrollY > 300) {
    toTop.classList.add("show");
  } else {
    toTop.classList.remove("show");
  }
};

// Listen for scroll events
window.addEventListener("scroll", toggleVisible);

// FIX: Also run it on load to catch "halfway down" reloads
window.addEventListener("DOMContentLoaded", toggleVisible);

// Scroll to top on click
toTop.addEventListener("click", () => {
  window.scrollTo({ top: 0, behavior: "smooth" });
});
